/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';
/**
 * An edit icon.
 * Used for editing tasting notes for example.
 *
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function FilterIcon({ className, size = 'xsmall' }) {
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", 
        // @ts-ignore
        sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, className: className, viewBox: "0 0 20 20" },
        jsx("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
            jsx("g", { fill: "currentColor", fillRule: "nonzero" },
                jsx("path", { d: "M15 .998v9.533a4 4 0 010 7.938V21h-1v-2.53a4 4 0 010-7.94V.999h1zM6 1v2.531a4 4 0 010 7.938V21H5v-9.53a4 4 0 010-7.94V1h1zm8.5 10.5a3 3 0 100 6 3 3 0 000-6zm-9-7a3 3 0 100 6 3 3 0 000-6z" })))));
}
//# sourceMappingURL=FilterIcon.js.map